import { render, staticRenderFns } from "./material_table.vue?vue&type=template&id=47684f02&scoped=true&"
import script from "./material_table.vue?vue&type=script&lang=js&"
export * from "./material_table.vue?vue&type=script&lang=js&"
import style0 from "./material_table.vue?vue&type=style&index=0&id=47684f02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47684f02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47684f02')) {
      api.createRecord('47684f02', component.options)
    } else {
      api.reload('47684f02', component.options)
    }
    module.hot.accept("./material_table.vue?vue&type=template&id=47684f02&scoped=true&", function () {
      api.rerender('47684f02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/marketing_promote/components/material_table.vue"
export default component.exports